import { motion } from "framer-motion";
import { MapPin, Clock, Mail } from "lucide-react";
import BookingForm from "@/components/BookingForm";
import { useStudio } from "@/context/StudioContext";

export default function Showroom() {
  const { openSample } = useStudio();
  return (
    <section id="contact" className="relative bg-[#121315] py-28 md:py-44 overflow-hidden cv-auto">
      {/* ambient showroom glow */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(140,115,85,0.12), rgba(18,19,21,0) 60%)" }} />

      <div className="mx-auto max-w-[1600px] px-6 md:px-12 relative">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Left — destination */}
          <div>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
              className="text-[#C9A876] text-[11px] tracking-[0.4em] uppercase mb-8">The Destination</motion.p>
            <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif-display text-[#F5F4F0] font-light tracking-tight text-4xl md:text-6xl leading-[1.02]">
              184 Victoria Road, Drummoyne
            </motion.h2>
            <p className="mt-6 text-[#D6D1CA]/80 text-lg font-body max-w-md">A one-stop selection studio — where the whole material puzzle comes together under one roof.</p>

            <div className="mt-12 space-y-6">
              {[
                { icon: MapPin, label: "Studio", val: "184 Victoria Road, Drummoyne NSW 2047" },
                { icon: Clock, label: "Hours", val: "Monday - Friday: 9:00am - 5:00pm\nSaturday: By Appointment\nSunday: Closed" },
                { icon: Mail, label: "Enquiries", val: "info@myfloorstudio.com.au" },
              ].map((r) => (
                <div key={r.label} className="flex items-start gap-5 border-t border-[#8C7355]/15 pt-6">
                  <r.icon size={18} className="text-[#C9A876] mt-1 shrink-0" />
                  <div>
                    <p className="text-[#C9A876] text-[10px] tracking-[0.3em] uppercase">{r.label}</p>
                    <p className="text-[#F5F4F0] text-base md:text-lg font-body mt-1 whitespace-pre-line">{r.val}</p>
                  </div>
                </div>
              ))}
            </div>

            <button data-testid="showroom-sample-btn" onClick={openSample}
              className="mt-12 link-underline text-[#D6D1CA] text-sm tracking-[0.15em] uppercase">
              Request a sample →
            </button>
          </div>

          {/* Right — booking module */}
          <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="bg-[#1a1b1e]/60 backdrop-blur-md border border-[#8C7355]/20 p-8 md:p-10 rounded-sm">
            <p className="text-[#C9A876] text-[10px] tracking-[0.4em] uppercase mb-2">Booking Module</p>
            <h3 className="font-serif-display text-[#F5F4F0] text-2xl md:text-3xl font-light mb-8">Schedule a private consultation</h3>
            <BookingForm prefix="showroom-booking" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
